export enum DeviceSize {
  MobileMin = "0",
  MobileMax = "640px",
  TabletMin = "641px",
  TabletMedium = "768px",
  TabletMax = "1024px",
  DesktopMin = "1025px",
  DesktopMedium = "1280px",
  DesktopMax = "1920px",
}
